// jestテスト対応のため、相対パスでimport
import moment from "../../moment";

// jestテスト用に、日付指定も可能に(デフォルトは指定なし)
export const getUrlForReports = (testDate) => {
  const now = testDate ?? new Date();
  // 期間の最大範囲は3ヶ月なので3ヶ月前の日付を指定。
  // 4/30 ~ 7/31のように、開始日付のDay < 終了日付のDay の場合、APIでエラーになる
  const threeMonthAgo = moment(now).subtract(3, "M");
  const startDate = moment(
    new Date(threeMonthAgo.year(), threeMonthAgo.month(), now.getDate())
  ).format("YYYYMMDD");

  const endDate = moment(now).format("YYYYMMDD");

  return `dbs/reports/?start_date=${startDate}&end_date=${endDate}`;
};
